module.exports = __webpack_public_path__ + "img/concept-idea-innovation-212286-HiRes.9d284a7d.jpg";